var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15 18",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.163 17.737a.966.966 0 01-1.326 0l-2.813-2.7a.874.874 0 010-1.274.966.966 0 011.327 0l1.212 1.164V6.3a.939.939 0 011.875 0v8.627l1.211-1.164a.966.966 0 011.327 0 .874.874 0 010 1.274l-2.813 2.7zM15 9.9a1.84 1.84 0 01-1.875 1.8H11.25a.9.9 0 110-1.8h1.875V1.8H1.875v8.1H3.75a.9.9 0 110 1.8H1.875A1.84 1.84 0 010 9.9V1.8A1.839 1.839 0 011.875 0h11.25A1.839 1.839 0 0115 1.8v8.1z"
  })));
}
export default SvgDownload;